import { render, staticRenderFns } from "./plainTable.vue?vue&type=template&id=215aa79f&scoped=true&"
import script from "./plainTable.vue?vue&type=script&lang=js&"
export * from "./plainTable.vue?vue&type=script&lang=js&"
import style0 from "./plainTable.vue?vue&type=style&index=0&id=215aa79f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215aa79f",
  null
  
)

export default component.exports